import { useIntegratedForm } from '../../../../forms/use-integrated-form';
import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { BoloPanelFormType } from '@mark43/cad-api';
import { VStack, Text, DataList, DataItem } from '@cad-arc';
import { formatMonthDayYearHoursMinutes } from '../../../../common/helpers/utils';
import { SectionTitle } from '../../../../fr-event-common-components/section-title';
import { BoloLabelPill } from '../../../../bolos/bolo-queues/components/cells/bolo-labels-cell';

export const FrBoloDetailsTabInformationSection = () => {
    const { form: boloForm } = useIntegratedForm<BoloPanelFormType>();
    const metadata = useBoloPanelMetadata();

    const { boloType, priority, description, scheduledExpirationDate, labels } = boloForm.watch();

    if (!metadata) {
        return null;
    }

    return (
        <VStack alignItems="flex-start" gap={2} w="100%" h="100%">
            <SectionTitle title="Information" />

            <DataList direction="row">
                <DataItem dataKey="BOLO Type">{boloType?.label}</DataItem>
                <DataItem dataKey="Priority">{priority?.label}</DataItem>
                <DataItem dataKey="Expiration Date">
                    {scheduledExpirationDate
                        ? formatMonthDayYearHoursMinutes(scheduledExpirationDate)
                        : null}
                </DataItem>
            </DataList>
            <DataList style={{ width: '100%' }}>
                <DataItem variant="stacked" dataKey="Description">
                    <Text style={{ wordWrap: 'break-word', width: '100%' }}>{description}</Text>
                </DataItem>
            </DataList>
            <DataList>
                <DataItem dataKey="Labels" variant="stacked">
                    {labels.length
                        ? labels.map((l) => <BoloLabelPill key={l.value} label={l} />)
                        : null}
                </DataItem>
            </DataList>
        </VStack>
    );
};
